function hasActiveSubStep(stepDetail) {
  const hasSubSteps = !!stepDetail.subSteps;
  return hasSubSteps && stepDetail.subSteps.activeStepIndex !== undefined;
}

export function isFirstWorkflowStep(workflowSteps, activeStepIndex) {
  if (activeStepIndex === undefined || activeStepIndex === null) {
    return true;
  }
  if (activeStepIndex !== 0) {
    return false;
  }
  if (workflowSteps[activeStepIndex].subSteps) {
    return isFirstWorkflowStep(
      workflowSteps[activeStepIndex].subSteps.workflowSteps,
      workflowSteps[activeStepIndex].subSteps.activeStepIndex,
    );
  }
  return true;
}

export function isLastWorkflowStep(workflowSteps, activeStepIndex) {
  if (activeStepIndex === undefined || activeStepIndex === null) {
    return true;
  }
  if (activeStepIndex !== workflowSteps.length - 1) {
    return false;
  }
  if (workflowSteps[activeStepIndex].subSteps) {
    return isLastWorkflowStep(
      workflowSteps[activeStepIndex].subSteps.workflowSteps,
      workflowSteps[activeStepIndex].subSteps.activeStepIndex,
    );
  }
  return true;
}

export function getActiveStepDetail(workflowSteps, activeStepIndex) {
  const activeRootStep = workflowSteps[activeStepIndex];
  return hasActiveSubStep(activeRootStep)
    ? activeRootStep.subSteps.workflowSteps[activeRootStep.subSteps.activeStepIndex]
    : activeRootStep;
}
